module.exports = __webpack_public_path__ + "img/sankaku_42_red.135b38a3.png";